import { fluid } from '@helpers/fluid';
import { contentStyles, h1, tag } from '@helpers/typography';
import styled from 'styled-components';
import ButtonStyles from '../Button/Button.styles';
import CtaLinkStyles from '../CtaLink/CtaLink.styles';
const Container = styled.div `
  margin: 0 auto ${fluid(30, 48)};
  max-width: 1366px;
  text-align: center;

  ${ButtonStyles.Container},
  ${CtaLinkStyles.Container} {
    margin-top: ${fluid(18, 24)};
  }
`;
const Title = styled.h2 `
  ${h1};
`;
const Subtitle = styled.span `
  ${tag};

  margin: 0 0 ${fluid(6, 8)};
`;
const Content = styled.div `
  ${contentStyles};

  p:last-child {
    margin-bottom: 0;
  }

  max-width: 738px;
  margin: 0 auto;
`;
const SectionHeaderStyles = {
    Container,
    Title,
    Subtitle,
    Content,
};
export default SectionHeaderStyles;
